import { getNodeData, setNodeData } from "../utility/nodeDataHelpers";

const KEY_NODE_ID = 'fvUid';
const KEY_DS_NAME = 'fvDs';

// object for storing an id => node mapping for quick retrieval of nodes based on a single value
function domNodeMap(dataSourceName) {
    let map = {};
    let nextId = 0;

    function getNode(id) {
        return map[id];
    }

    function setId(node) {
        const id = "N" + nextId;

        setNodeData(node, KEY_NODE_ID, id);
        if (dataSourceName) {
            setNodeData(node, KEY_DS_NAME, dataSourceName);
        }
        map[id] = node;

        nextId += 1;
    }

    function purgeNodes() {
        map = {};
    }

    function addNode(node) {
        var curVal = getNodeData(node, KEY_NODE_ID);

        if (!(curVal && (getNode(curVal) === node))) {
            setId(node);
        }
    }

    function assignAllIds(nodes) {
        for (const node of nodes) {
            addNode(node);

            assignAllIds(Array.from(node.childNodes || []));
            assignAllIds(Array.from(node.attributes || []));
        }
    }

    const assignIds = (n) => assignAllIds([n]);

    return {
        addNode,
        getNode,
        assignIds,
        purgeNodes
    };
}

export default domNodeMap;